import { AppStore, getAppSelection } from '@alfresco/aca-shared/store';
import { ExtensionLoaderService, ExtensionService } from '@alfresco/adf-extensions';
import { NodeEntry } from '@alfresco/js-api';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { AldenService } from '../../../services/alden.service';

@Component({
  templateUrl: './custom-action-inline.component.html',
  styleUrls: ['./custom-action-inline.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class CustomActionInlineComponent implements OnChanges, OnDestroy {

  @Input() id: string;
  @Input() data: { title?: string; image?: boolean, icon?: string, action?: string, nodeEntry?: NodeEntry }

  onDestroy$: Subject<boolean> = new Subject();
  loading: boolean;

  nodeEntry: NodeEntry;

  constructor(
    protected extensionService: ExtensionService,
    protected store: Store<AppStore>,
    protected loader: ExtensionLoaderService,
    private aldenService: AldenService
  ) { 
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    const currentValue = changes.data.currentValue;
    this.nodeEntry = currentValue.nodeEntry;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  handleAction(actionId: string) {
    if(actionId) {
      if(this.nodeEntry) {
        const selectionState = this.aldenService.getSelectionState(this.nodeEntry);
        this.store.dispatch({ type: actionId, selection: selectionState });
      } else {
        this.store.select(getAppSelection).pipe(take(1)).subscribe((selection) => {
          this.store.dispatch({ type: actionId, selection: selection });
        });  
      } 
    }
  }
}
